<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogFeedNewsComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogFeedNewsComponent'></options-element-bar>

        <template-simple></template-simple>


      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import Resources from './Resources.vue';
import TemplateSimple from './templates/Simple'

export default {
  name: 'BlogFeedNewsComponent',
  props: ['config', 'id'],
  components: { OptionsElementBar, Resources, TemplateSimple },
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = {...this.internal_config, ...config};
    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `width: ${this.internal_config.width};
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$refs.resourcesData.setValuesData(this);
  }
};
</script>

<style>

  [element="BlogFeedNewsComponent"] .vdr {
    height: auto !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Feed/FeedNews.vue